import { ReactElement } from 'react';
import { Trans } from 'react-i18next';

import { ButtonLinkW, Description, EmptyStateIconW, EmptyStateW, NavLinkW } from './styled';

interface GoalEmptyStateProps {
  addGoalLink: string;
  onAddGoal?: () => void;
}

export function GoalEmptyState({ addGoalLink, onAddGoal }: GoalEmptyStateProps): ReactElement {
  return (
    <EmptyStateW>
      <EmptyStateIconW />
      <Description>
        {onAddGoal ? (
          <Trans i18nKey="career.goals.emptyState">
            Nothing is here yet.
            <ButtonLinkW onClick={onAddGoal}>Create a sub-goal</ButtonLinkW> to place to place
            sub-goals in progress!
          </Trans>
        ) : (
          <Trans i18nKey="career.goals.emptyState">
            Nothing is here yet.
            <NavLinkW to={addGoalLink}>Create a sub-goal</NavLinkW> to place to place sub-goals in
            progress!
          </Trans>
        )}
      </Description>
    </EmptyStateW>
  );
}
